module.exports = __webpack_public_path__ + "media/images/no_content.icon.search-1cdfdb1a.png";